import { Link } from "react-router-dom";
import HeaderIcon from "@components/HeaderIcon.jsx";

const PrivacyPolicyPage = () => {
    return (
        <div className="privacy-policy">
            <div className="wrapper">
                <HeaderIcon />
                <div className="privacy-policy-box">
                    <Link to="/auth/sign-in" className="privacy-policy-box__back">
                        ← Back
                    </Link>

                    <h1>Privacy Policy</h1>
                    <p className="privacy-policy-box__updated">
                        <strong>Last Updated: July 2026</strong>
                    </p>

                    <h2>1. General Provisions</h2>
                    <p>
                        This Privacy Policy has been prepared in accordance with applicable
                        data protection laws and regulations and defines the procedure for
                        processing personal data and measures taken to ensure the security
                        of personal data by <strong>Appwarehouse General Technology LLC</strong>{" "}
                        (hereinafter referred to as the "Operator").
                    </p>
                    <p>
                        The Operator considers the protection of personal data and privacy
                        rights to be one of its highest priorities. This Privacy Policy
                        applies to all information that the Operator may obtain about
                        visitors and users of the website:
                    </p>
                    <p>
                        <a href="https://appwarehouse.xyz" target="_blank" rel="noopener noreferrer">
                            https://appwarehouse.xyz
                        </a>
                    </p>

                    <h2>2. Definitions</h2>
                    <p>
                        For the purposes of this Privacy Policy, the following terms shall
                        have the meanings set forth below:
                    </p>
                    <p>
                        <strong>Personal Data</strong> – any information relating directly
                        or indirectly to an identified or identifiable natural person.
                    </p>
                    <p>
                        <strong>Processing of Personal Data</strong> – any operation or set
                        of operations performed on personal data, including collection,
                        recording, organization, storage, updating, retrieval, use,
                        transfer, anonymization, blocking, deletion, or destruction.
                    </p>
                    <p>
                        <strong>Automated Processing</strong> – processing of personal data
                        using computer technology.
                    </p>
                    <p>
                        <strong>Website</strong> – the website located at:{" "}
                        <a href="https://appwarehouse.xyz" target="_blank" rel="noopener noreferrer">
                            https://appwarehouse.xyz
                        </a>
                    </p>
                    <p>
                        <strong>User</strong> – any visitor of the Website.
                    </p>
                    <p>
                        <strong>Operator</strong> – Appwarehouse General Technology LLC,
                        which independently determines the purposes and means of processing
                        personal data.
                    </p>
                    <p>
                        <strong>Cookies</strong> – small text files stored on the User's
                        device to improve website functionality and user experience.
                    </p>
                    <p>
                        <strong>Anonymized Data</strong> – data that cannot be used to
                        identify a specific individual without additional information.
                    </p>
                    <p>
                        <strong>Cross-Border Data Transfer</strong> – transfer of personal
                        data to a foreign country, foreign legal entity, or foreign
                        individual.
                    </p>

                    <h2>3. Personal Data We Collect</h2>
                    <p>
                        The Operator may collect and process the following categories of
                        personal data:
                    </p>
                    <ul>
                        <li>Full name;</li>
                        <li>Email address;</li>
                        <li>Phone number;</li>
                        <li>Company name (if provided);</li>
                        <li>Information submitted through contact forms;</li>
                        <li>
                            Technical and analytical information collected automatically
                            through cookies and analytics tools.
                        </li>
                    </ul>
                    <p>
                        The Website may also collect anonymized information about Users
                        through:
                    </p>
                    <ul>
                        <li>Google Analytics;</li>
                        <li>Google Search Console;</li>
                        <li>Other web analytics and performance monitoring services.</li>
                    </ul>
                    <p>
                        All of the above information is collectively referred to as{" "}
                        <strong>Personal Data</strong>.
                    </p>

                    <h2>4. Purposes of Data Processing</h2>
                    <p>The Operator processes Personal Data for the following purposes:</p>
                    <ul>
                        <li>Providing services requested by Users;</li>
                        <li>Responding to inquiries and support requests;</li>
                        <li>Maintaining communication with Users;</li>
                        <li>
                            Sending notifications regarding services, updates, and important
                            information;
                        </li>
                        <li>Improving website functionality and user experience;</li>
                        <li>Conducting analytics and performance monitoring;</li>
                        <li>Complying with legal obligations.</li>
                    </ul>
                    <p>
                        The Operator may also send marketing communications, promotional
                        offers, and information about products and services.
                    </p>
                    <p>
                        Users may unsubscribe from marketing communications at any time by
                        contacting:
                    </p>
                    <p>
                        <strong>lorasupport@appwarehouse.xyz</strong>
                    </p>
                    <p>with the subject line:</p>
                    <p>
                        <strong>"Unsubscribe from Marketing Communications"</strong>
                    </p>

                    <h2>5. Legal Basis for Processing</h2>
                    <p>The Operator processes Personal Data only when:</p>
                    <ul>
                        <li>
                            The User voluntarily submits such information through forms
                            available on the Website;
                        </li>
                        <li>The User contacts the Operator directly;</li>
                        <li>The User provides consent;</li>
                        <li>Processing is necessary for the performance of a contract;</li>
                        <li>Processing is required by applicable law.</li>
                    </ul>
                    <p>
                        By submitting Personal Data through the Website, the User
                        acknowledges and agrees to this Privacy Policy.
                    </p>

                    <h2>6. Data Storage, Protection, and Security</h2>
                    <p>
                        The Operator implements appropriate technical, organizational, and
                        administrative safeguards to protect Personal Data against
                        unauthorized access, disclosure, alteration, or destruction.
                    </p>
                    <p>The Operator undertakes reasonable measures to ensure:</p>
                    <ul>
                        <li>Confidentiality of Personal Data;</li>
                        <li>Secure storage and transmission of information;</li>
                        <li>Restricted access to authorized personnel only.</li>
                    </ul>
                    <p>
                        Personal Data will not be sold, rented, or disclosed to third
                        parties except:
                    </p>
                    <ul>
                        <li>When required by applicable law;</li>
                        <li>When necessary to provide requested services;</li>
                        <li>When the User has provided explicit consent.</li>
                    </ul>
                    <p>
                        Users may request correction or update of their Personal Data by
                        contacting:
                    </p>
                    <p>
                        <strong>lorasupport@appwarehouse.xyz</strong>
                    </p>
                    <p>with the subject line:</p>
                    <p>
                        <strong>"Personal Data Update Request"</strong>
                    </p>
                    <p>
                        Users may also withdraw consent to the processing of their Personal
                        Data at any time by contacting:
                    </p>
                    <p>
                        <strong>lorasupport@appwarehouse.xyz</strong>
                    </p>
                    <p>with the subject line:</p>
                    <p>
                        <strong>"Withdrawal of Consent for Personal Data Processing"</strong>
                    </p>

                    <h2>7. Data Retention</h2>
                    <p>
                        Personal Data shall be retained only for as long as necessary to
                        fulfill the purposes outlined in this Privacy Policy, comply with
                        legal obligations, resolve disputes, and enforce agreements.
                    </p>
                    <p>
                        When Personal Data is no longer required, it will be securely
                        deleted or anonymized.
                    </p>

                    <h2>8. Cross-Border Transfers</h2>
                    <p>
                        Given the international nature of the Operator's business
                        activities, Personal Data may be transferred to and processed in
                        countries outside the User's country of residence.
                    </p>
                    <p>
                        The Operator shall take reasonable steps to ensure that such
                        transfers are conducted in accordance with applicable data
                        protection laws and that adequate safeguards are implemented to
                        protect Personal Data.
                    </p>

                    <h2>9. Cookies and Analytics</h2>
                    <p>The Website uses cookies and similar technologies to:</p>
                    <ul>
                        <li>Improve Website functionality;</li>
                        <li>Analyze traffic and usage patterns;</li>
                        <li>Enhance User experience;</li>
                        <li>Provide relevant content and services.</li>
                    </ul>
                    <p>
                        Users may disable cookies through their browser settings; however,
                        certain website functions may become unavailable.
                    </p>

                    <h2>10. Contact Information</h2>
                    <p>
                        If you have any questions regarding this Privacy Policy or the
                        processing of Personal Data, please contact:
                    </p>
                    <p>
                        <strong>Appwarehouse General Technology LLC</strong>
                    </p>
                    <p>
                        <strong>Address:</strong> 9th Floor, Unit 6, Building C, Yingdu
                        Mansion, Zhichun Road, Haidian District, Beijing, China
                    </p>
                    <p>
                        <strong>Support Email:</strong> lorasupport@appwarehouse.xyz
                    </p>
                    <p>
                        <strong>Website:</strong>{" "}
                        <a href="https://appwarehouse.xyz" target="_blank" rel="noopener noreferrer">
                            https://appwarehouse.xyz
                        </a>
                    </p>

                    <h2>11. Changes to This Privacy Policy</h2>
                    <p>
                        The Operator reserves the right to update or modify this Privacy
                        Policy at any time.
                    </p>
                    <p>
                        Any changes will be published on this page, and the updated version
                        will become effective immediately upon publication.
                    </p>

                    <p className="privacy-policy-box__copyright">
                        © 2023–2026 Appwarehouse General Technology LLC. All Rights
                        Reserved.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
